import { useMemo } from "react";
import { useQuery } from "@apollo/client";

import { IntentProjectPolicyAttachment } from "types/generated";

import { GET_INTENT_PROJECT_POLICIES } from "./gql";

const useIntentProjectPolicies = (intentProjectId: string) => {
  const { data, loading, error } = useQuery(GET_INTENT_PROJECT_POLICIES, {
    variables: { id: intentProjectId },
    skip: !intentProjectId,
  });

  const attachedPolicies = useMemo<IntentProjectPolicyAttachment[]>(
    () => data?.intentProject?.attachedPolicies || [],
    [data?.intentProject?.attachedPolicies]
  );

  const attachablePolicies = useMemo(
    () => data?.intentProject?.attachablePolicies || [],
    [data?.intentProject?.attachablePolicies]
  );

  const [manuallyAttachedPolicies, autoAttachedPolicies] = useMemo(() => {
    return attachedPolicies.reduce<
      [IntentProjectPolicyAttachment[], IntentProjectPolicyAttachment[]]
    >(
      (acc, policy) => {
        if (policy.isAutoattached) {
          acc[1].push(policy);
        } else {
          acc[0].push(policy);
        }
        return acc;
      },
      [[], []]
    );
  }, [attachedPolicies]);

  return {
    manuallyAttachedPolicies,
    autoAttachedPolicies,
    attachablePolicies,
    loading,
    error,
  };
};

export default useIntentProjectPolicies;
